export const AUTH_TOKEN = 'authToken';
export const GOOGLE_TOKEN = 'googleToken';
export const APPLE_CODE = 'appleCode';
export const SIGN_UP_FLOW = 'signUpFlow';
export const CAMPAIGN = 'campaign';
export const INTERNAL_ANALYTICS_UUID = 'iaid';
export const SHOWN_PROFILE_PROGRESS = 'shProProgress';
